import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { BvBadgeVariant, BvBadgeComponent } from "./badge.component";

export type BvTournamentStatus =
  | "Scheduled"
  | "Running"
  | "Seating"
  | "Finished"
  | "Incomplete"
  | "Merged"
  | "Split";

/**
 * Tournament status pill. Maps a status string to a `bv-badge` variant
 * (with an optional pulse dot for live states). Translation/casing is
 * the consumer's job — project the rendered text via ng-content.
 *
 *   <bv-status-badge [status]="t.tournStatus">
 *     {{ t.tournStatus | uppercase | translate }}
 *   </bv-status-badge>
 */
@Component({
    selector: "bv-status-badge",
    template: `<bv-badge [variant]="variant" [dot]="dot"><ng-content></ng-content></bv-badge>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BvBadgeComponent]
})
export class BvStatusBadgeComponent {
  @Input() status: string = "";

  get variant(): BvBadgeVariant {
    switch (this.status) {
      case "Scheduled":
        return "info";
      case "Running":
        return "success";
      case "Seating":
        return "warning";
      case "Finished":
        return "error";
      case "Split":
        return "info";
      case "Incomplete":
        return "default";
      default:
        return "default";
    }
  }

  get dot(): boolean {
    return this.status === "Running" || this.status === "Seating";
  }
}
